var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loading
    ? _c("Loading")
    : _c(
        "Box",
        [
          _c(
            "Box",
            { staticClass: "main-header", attrs: { tag: "header" } },
            [
              _c(
                "Box",
                {
                  staticClass: "app-logo",
                  attrs: { tag: "header", display: "flex", flexAlign: "center" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "toggle-menu",
                      on: { click: _vm.toggleMenu }
                    },
                    [_c("Icon", { attrs: { name: "bars" } })],
                    1
                  ),
                  _c("h1", [
                    _c("img", {
                      staticClass: "logo",
                      attrs: {
                        src:
                          "https://res.cloudinary.com/orthodox-union/image/upload/v1457435023/Logos/ou_logo_transparent.png"
                      }
                    }),
                    _vm._v(" Velocity ")
                  ])
                ]
              ),
              _c("GlobalSearch", { staticClass: "main-search" }),
              _c(
                "Box",
                { staticClass: "user__actions", attrs: { display: "flex" } },
                [
                  _c(
                    "Popover",
                    { staticClass: "actions", attrs: { width: "140px" } },
                    [
                      _c("template", { slot: "content" }, [
                        _c(
                          "ul",
                          [
                            _c(
                              "li",
                              { staticClass: "popover-action" },
                              [
                                _c(
                                  "RouterLink",
                                  { attrs: { to: "/new-donor", exact: true } },
                                  [_vm._v("New Account")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "popover-action" },
                              [
                                _c(
                                  "RouterLink",
                                  { attrs: { to: "/new-pledge", exact: true } },
                                  [_vm._v("New Pledge")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              { staticClass: "popover-action" },
                              [
                                _c(
                                  "RouterLink",
                                  {
                                    attrs: { to: "/new-payment", exact: true }
                                  },
                                  [_vm._v("New Payment")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "ProtectedBlock",
                              {
                                attrs: {
                                  requiredRole: _vm.UserRole.AddCampaign
                                }
                              },
                              [
                                _c(
                                  "li",
                                  { staticClass: "popover-action" },
                                  [
                                    _c(
                                      "RouterLink",
                                      {
                                        attrs: {
                                          to: "/new-campaign",
                                          exact: true
                                        }
                                      },
                                      [_vm._v("New Campaign")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  ),
                  _c(
                    "Box",
                    { staticClass: "user-menu" },
                    [
                      _c(
                        "Popover",
                        {
                          staticClass: "actions",
                          attrs: { width: "150px", alignRight: "" }
                        },
                        [
                          _c(
                            "template",
                            { slot: "trigger" },
                            [
                              _c(
                                "Box",
                                {
                                  staticClass: "user__trigger",
                                  attrs: {
                                    display: "flex",
                                    flexAlign: "center"
                                  }
                                },
                                [
                                  _c("Avatar", {
                                    attrs: {
                                      rounded: "",
                                      username: `${_vm.currentUser.firstName} ${_vm.currentUser.lastName}`,
                                      size: 30
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("template", { slot: "content" }, [
                            _c("ul", [
                              _vm.canEmulate
                                ? _c("li", { staticClass: "popover-action" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.showEmulateDialog = true
                                          }
                                        }
                                      },
                                      [_vm._v("Switch Account")]
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "li",
                                { staticClass: "popover-action" },
                                [
                                  _c(
                                    "RouterLink",
                                    { attrs: { to: "/", exact: true } },
                                    [_vm._v("Logout")]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "Box",
            { staticClass: "wrapper", class: { menuOpen: _vm.menuOpen } },
            [
              _vm.showEmulateDialog
                ? _c(
                    "UserSelector",
                    _vm._b(
                      {
                        on: {
                          close: function($event) {
                            _vm.showEmulateDialog = false
                          }
                        }
                      },
                      "UserSelector",
                      _vm.userSelectorProps,
                      false
                    )
                  )
                : _vm._e(),
              _c("Box", { staticClass: "main-sidebar" }, [_c("MainNav")], 1),
              _c(
                "Box",
                { attrs: { tag: "main" } },
                [
                  _c(
                    "Box",
                    {
                      staticClass: "main-content",
                      class: { full: !_vm.menuOpen }
                    },
                    [
                      _c(
                        "ScrollablePanel",
                        [
                          _c(
                            "Route",
                            { attrs: { path: "/open-pledges" } },
                            [_c("OpenPledges")],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ViewTeachDashboard
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/teach-dashboard" } },
                                [_c("DashoboardTeachDashboard")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/ncsy-dashboard" } },
                            [_c("DashboardNCSYDashboard")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/engagement-report" } },
                            [_c("EngagementReport")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/library" } },
                            [_c("FundraisingLibrary")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/donor-list" } },
                            [_c("DonorListsPage")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/resources" } },
                            [_c("Resources")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/new-donor" } },
                            [_c("NewDonor")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/new-pledge" } },
                            [_c("NewPledge")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/new-payment" } },
                            [_c("NewPayment")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/new-grant" } },
                            [_c("NewGrant")],
                            1
                          ),
                          _vm.belongsToTeachCoalition
                            ? _c(
                                "Route",
                                { attrs: { path: "/networks" } },
                                [_c("OUANetworks")],
                                1
                              )
                            : _vm._e(),
                          _vm.belongsToTeachCoalition
                            ? _c(
                                "Route",
                                { attrs: { path: "/new-network" } },
                                [_c("NetworkForm")],
                                1
                              )
                            : _vm._e(),
                          _vm.belongsToTeachCoalition
                            ? _c("Route", {
                                attrs: { path: "/edit-network/:id" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ id }) {
                                        return [
                                          _c("NetworkForm", {
                                            attrs: { networkId: id }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4119898942
                                )
                              })
                            : _vm._e(),
                          _vm.belongsToTeachCoalition
                            ? _c("Route", {
                                attrs: { path: "/network/:id" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ id }) {
                                        return [
                                          _c("SingleNetwork", {
                                            attrs: { networkId: id }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3263645394
                                )
                              })
                            : _vm._e(),
                          _vm.belongsToTeachCoalition
                            ? _c(
                                "Route",
                                { attrs: { path: "/regions" } },
                                [_c("OUARegions")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: { requiredRole: _vm.UserRole.AddCampaign }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/new-campaign" } },
                                [_c("NewCampaign")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/campaigns" } },
                            [
                              _c(
                                "MatchFirst",
                                [
                                  _c(
                                    "Route",
                                    { attrs: { path: "/campaigns/gl-codes" } },
                                    [_c("CampaignsGlCodes")],
                                    1
                                  ),
                                  _c(
                                    "Route",
                                    { attrs: { path: "/campaigns" } },
                                    [_c("Campaigns")],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ManageBenefactor
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/benefactor" } },
                                [_c("Benefactor")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ManageBenefactor
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/benefactor-by-quarter" } },
                                [_c("BenefactorByQuarter")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            {
                              attrs: {
                                path: "/benefactor-members",
                                requiredRole: _vm.UserRole.ManageBenefactor
                              }
                            },
                            [_c("BenefactorMembers")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/pg" } },
                            [_c("PlannedGiving")],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ManageEmployees
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/ouemployees" } },
                                [_c("Employees")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ManageBoardMembers
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/boardmembers" } },
                                [_c("Boardmembers")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ManageBoardMembers
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/board-list" } },
                                [_c("BoardList")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ManageBoardMembers
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/boardmembers-payments" } },
                                [_c("BoardmembersPayments")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole:
                                  _vm.UserRole
                                    .ManageCommissionAndCommitteeMembers
                              }
                            },
                            [
                              _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/commission-members",
                                    exact: true
                                  }
                                },
                                [_c("CommissionMembers")],
                                1
                              ),
                              _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/commission-member/payments",
                                    exact: true
                                  }
                                },
                                [_c("CommissionMembersPayments")],
                                1
                              ),
                              _c(
                                "Route",
                                { attrs: { path: "/committee-members" } },
                                [_c("CommitteeMembers")],
                                1
                              ),
                              _c(
                                "Route",
                                {
                                  attrs: { path: "/committee-member/payments" }
                                },
                                [_c("CommitteeMembersPayments")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/dashboards" } },
                            [_c("Dashboards")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/foundations", exact: true } },
                            [_c("Foundations")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/foundations/report" } },
                            [_c("FoundationsReport")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/moves" } },
                            [_c("Moves")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/pledges" } },
                            [_c("PledgeManagment")],
                            1
                          ),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/pledges-today" } },
                                [_c("PledgeToday")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: { requiredRole: _vm.UserRole.ViewBatches }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/batches" } },
                                [
                                  _c(
                                    "MatchFirst",
                                    [
                                      _c("Route", {
                                        attrs: { path: "/batches/:id" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "default",
                                            fn: function({ id }) {
                                              return [
                                                _c("Batch", {
                                                  attrs: { batchId: id }
                                                })
                                              ]
                                            }
                                          }
                                        ])
                                      }),
                                      _c(
                                        "Route",
                                        { attrs: { path: "/batches" } },
                                        [_c("Batches")],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "Route",
                                { attrs: { path: "/batch/new" } },
                                [_c("NewBatch")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/departments" } },
                            [_c("Departments")],
                            1
                          ),
                          _vm.canGenerateInvoicesAndReceipts()
                            ? _c(
                                "Route",
                                { attrs: { path: "/generateinvoice" } },
                                [_c("GenerateInvoice")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: { path: "/generate-membership-cards" }
                                },
                                [_c("GenerateMembershipCards")],
                                1
                              )
                            : _vm._e(),
                          _c("Route", {
                            attrs: { path: "/department/:id" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ id }) {
                                  return [
                                    _c("Department", { attrs: { id: id } })
                                  ]
                                }
                              }
                            ])
                          }),
                          _c(
                            "Route",
                            { attrs: { path: "/duplicates" } },
                            [_c("Dups")],
                            1
                          ),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/users" } },
                                [_c("Users")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c("Route", {
                                attrs: { path: "/user/:id" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ id }) {
                                        return [
                                          _c("User", { attrs: { id: id } })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  774588057
                                )
                              })
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/new-user" } },
                                [_c("NewUser")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/webimports" } },
                                [
                                  _c("WebImports", {
                                    attrs: {
                                      title: "Web Imports",
                                      excludeSource: "priority"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/priority-imports" } },
                                [
                                  _c("WebImports", {
                                    attrs: {
                                      title: "Priority Imports",
                                      source: "priority",
                                      paymentsOnly: true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: { path: "/dataservices/priority-sync" }
                                },
                                [_c("PrioritySync")],
                                1
                              )
                            : _vm._e(),
                          _vm.currentUser.type === _vm.UserType.DataServices
                            ? _c(
                                "Route",
                                {
                                  attrs: { path: "/dataservices/nova-matching" }
                                },
                                [_c("NovaMatchingDashboard")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "Route",
                            { attrs: { path: "/search" } },
                            [_c("Search")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/missing-address" } },
                            [_c("DonorsWOAddress")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/missing-salutation" } },
                            [_c("DonorsWOSalutation")],
                            1
                          ),
                          _c("Route", {
                            attrs: { path: "/campaign/:id" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ id }) {
                                  return [_c("Campaign", { attrs: { id: id } })]
                                }
                              }
                            ])
                          }),
                          _c("Route", {
                            attrs: { path: "/household/:id" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function({ id }) {
                                  return [
                                    _c(
                                      "Households",
                                      _vm._b({}, "Households", { id }, false)
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c(
                            "Route",
                            { attrs: { path: "/dataservices/mapping" } },
                            [_c("AdmireMapping")],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRole: _vm.UserRole.ViewNewDonors
                              }
                            },
                            [
                              _c(
                                "Route",
                                {
                                  attrs: { path: "/dataservices/newhouseholds" }
                                },
                                [_c("NewHouseholds")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRoles: [
                                  _vm.UserRole.ViewPending,
                                  _vm.UserRole.ManageRM
                                ]
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/dataservices/pending" } },
                                [_c("Pending")],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/checks",
                                    exact: true
                                  }
                                },
                                [_c("Checks")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: { requiredRole: _vm.UserRole.ChecksUpload }
                            },
                            [
                              _vm.canAccessDataservices
                                ? _c(
                                    "Route",
                                    {
                                      attrs: {
                                        path: "/dataservices/checks/upload",
                                        exact: true
                                      }
                                    },
                                    [_c("UploadChecks")],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/canada-imports",
                                    exact: true
                                  }
                                },
                                [_c("SFCanadaImport")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/xls-imports",
                                    exact: true
                                  }
                                },
                                [_c("XlsImport")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/cds-imports",
                                    exact: true
                                  }
                                },
                                [_c("CdsImport")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices ||
                          _vm.hasRole(_vm.UserRole.ViewCauseMatchImports)
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/causematch-imports",
                                    exact: true
                                  }
                                },
                                [_c("CauseMatchImport")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/solicitation-imports",
                                    exact: true
                                  }
                                },
                                [_c("SolicitationsImport")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                {
                                  attrs: {
                                    path: "/dataservices/donors-by-emails",
                                    exact: true
                                  }
                                },
                                [_c("DonorsByEmails")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/bulk-pledge" } },
                                [_c("BulkPledgeChanges")],
                                1
                              )
                            : _vm._e(),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/bulk-payment" } },
                                [_c("BulkPaymentChanges")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "Route",
                            { attrs: { path: "/donors" } },
                            [_c("Donors")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/pipeline" } },
                            [_c("GoalPipeline")],
                            1
                          ),
                          _vm.canAccessDataservices ||
                          _vm.hasRole(_vm.UserRole.ViewGoalsReport)
                            ? _c(
                                "Route",
                                { attrs: { path: "/goals-report" } },
                                [_c("GoalsReport")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "Route",
                            { attrs: { path: "/reports" } },
                            [_c("Reports")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/dynamic-reports" } },
                            [_c("DynamicReports")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/reconciliation" } },
                            [_c("Reconciliation")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/reconciliation-cardknox" } },
                            [_c("ReconciliationCardknox")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/fundraiser-actions" } },
                            [
                              _c(
                                "MatchFirst",
                                [
                                  _c("Route", {
                                    attrs: {
                                      path: "/fundraiser-actions/:id/:pageType"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function({ id, pageType }) {
                                          return [
                                            _c("FundraiserActions", {
                                              attrs: {
                                                userId: id,
                                                pageType: pageType
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c(
                                    "Route",
                                    { attrs: { path: "/fundraiser-actions" } },
                                    [
                                      _c("Redirect", {
                                        attrs: {
                                          to: `/fundraiser-actions/${_vm.currentUser.id}/pledges`
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRoles: [_vm.UserRole.ViewQiuckLookup]
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/lookup" } },
                                [_c("QuickLookup")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/payments" } },
                            [_c("Payments")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/receipt-summary" } },
                            [_c("ReceiptSummary")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/grants" } },
                            [_c("Grants")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/grant-ideas" } },
                            [_c("GrantIdeas")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/retention" } },
                            [_c("Retention")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/outgoing-sms" } },
                            [_c("OutgoingSMS")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/ou-fundraising" } },
                            [_c("OuFundrasing")],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRoles: [
                                  _vm.UserRole.ViewLeadershipReports
                                ]
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/leadership-reports" } },
                                [_c("LeadershipReports")],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.canAccessDataservices
                            ? _c(
                                "Route",
                                { attrs: { path: "/debt-report" } },
                                [_c("DebtReport")],
                                1
                              )
                            : _vm._e(),
                          _vm.isAccounting ||
                          _vm.hasRole(_vm.UserRole.ViewFundraisingBudget)
                            ? _c(
                                "Route",
                                { attrs: { path: "/fundraising-budget" } },
                                [_c("AccountingBudget")],
                                1
                              )
                            : _vm._e(),
                          _vm.isAccounting ||
                          _vm.hasRole(_vm.UserRole.ManageNetsuiteMapping)
                            ? _c(
                                "Route",
                                { attrs: { path: "/netsuite-sync" } },
                                [_c("NetsuiteSync")],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "Route",
                            { attrs: { path: "/", exact: "" } },
                            [
                              _c("Redirect", {
                                attrs: { to: _vm.mainPageRedirectUrl }
                              })
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/recurring-payments" } },
                            [_c("RecurringPayments")],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRoles: [_vm.UserRole.ViewOuMemebers]
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/ou-membership" } },
                                [_c("OuMembership")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRoles: [_vm.UserRole.ViewOuMemebers]
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/telemarketing" } },
                                [_c("Telemarketing")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/voice-broadcast" } },
                            [_c("VoiceBroadcast")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/notifications" } },
                            [_c("NotificationSettings")],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/dafpay" } },
                            [_c("UnclearedDafPledgesPage")],
                            1
                          ),
                          _c(
                            "ProtectedBlock",
                            {
                              attrs: {
                                requiredRoles: [
                                  _vm.UserRole.ViewDirectMailProspects
                                ]
                              }
                            },
                            [
                              _c(
                                "Route",
                                { attrs: { path: "/direct-mail-prospects" } },
                                [_c("DirectMailProspects")],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "Route",
                            { attrs: { path: "/pending-ach-payments" } },
                            [_c("PendingAchPayments")],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("NotificationsContainer")
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }